import React, { useEffect, useState } from 'react';
import { CustomInputBox, EmailInput } from 'Components/Input/Input';
import axiosInstance from 'Utils/Interceptor';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { object, string } from 'yup';
import ThankYouModalForCallBack from './ThankYouModal';
import CustomModal from 'Components/Modal/CustomModal';
import { useDispatch, useSelector } from 'react-redux';
import { setLoader } from '../../../Redux/features/LoaderSlice';
import SelectBox from 'Components/Select/Select';
import ReCAPTCHA from 'react-google-recaptcha';
import { Config } from 'Utils/Config';
import { EMAIL_REGEX, NUMBER_REGEX } from 'Utils/Constant';
import { NameInput } from 'Components/NameInput/NameInput';
import { NumberInput } from 'Components/NumberInput/NumberInput';
import { useNavigate } from 'react-router-dom';

const validationSchemaForEditProfileModal = object({
  first_name: string().required('First Name is required')
  .matches(
    /^[a-zA-Z ]+$/,
    'Only alphabets are accepted',
  ),
  last_name: string()
  .matches(
    /^[a-zA-Z ]+$/,
    'Only alphabets are accepted',
  ),
  email: string().matches(EMAIL_REGEX, 'Please enter a valid email id'),
  mobileno: string()
  .required('Mobile number is required')
  .max(10, 'Mobile number must be 10 digits')
  .min(10, 'Mobile number must be 10 digits')
  .matches(NUMBER_REGEX, 'Please enter a valid mobile number'),
  city: object().nullable().required('City is required'),
  slots: object().nullable().required('Time is required'),
  recaptcha: string().required('Please complete the CAPTCHA'),
  test_category: object().nullable().required('Test category is required') // New fie
});

function CallBackModal({
  handleCloseModal,
  showGetACallBack,
  setShowThankYouModal
}) {
  const [cityList, setCityList] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [testCategories, setTestCategories] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    profile: { email, mobileno, last_name, first_name }
  } = useSelector((state) => state.login);

  const formik = useFormik({
    initialValues: {
      first_name: first_name,
      last_name: last_name,
      email: email,
      mobileno: mobileno,
      city: null,
      slots: null,
      recaptcha: '',
      test_category: null
    },
    validationSchema: validationSchemaForEditProfileModal,
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (formikvalues, { setSubmitting }) => {
      setSubmitting(true);
      dispatch(setLoader(true));
      try {
        await axiosInstance.post('/api/user/getacallback', {
          first_name: formikvalues.first_name,
          last_name: formikvalues.last_name,
          mobileno: formikvalues?.mobileno,
          email: formikvalues.email,
          timeslot: formikvalues.slots?.value,
          city_id: formikvalues.city?.value,
          test_category: formikvalues?.test_category?.value
        });

        // setShowThankYouModal(true);
        navigate('/thank-you')
        handleCloseModal();

      } catch (errors) {
        toast.error(errors?.data?.error?.message, {});
      }
      dispatch(setLoader(false));
    }
  });

  const onChangeCaptcha = (value) => {
    setCaptchaValue(value);
    formik.setFieldValue('recaptcha', value);
  };

  const fetchTestCategories = async () => {
    dispatch(setLoader(true));
    try {
      const { data } = await axiosInstance(`/api/user/test-categories`);
      if (data) {
        const categories = data.data.map((e) => ({
          label: e,
          value: e
        }));
        setTestCategories(categories);
      }
    } catch (error) {
      toast.error('Failed to load test categories');
    }
    dispatch(setLoader(false));
  };

  const fetchCities = async (stateId) => {
    dispatch(setLoader(true));
    try {
      const { data } = await axiosInstance(`/api/user/cities`);
      if (data) {
        const cities = data.data.map((e) => ({
          label: e.city_name,
          value: e.city_id
        }));
        setCityList(cities);
      }
    } catch (error) {}
    dispatch(setLoader(false));
  };

  const fetchTimeSlots = async (stateId) => {
    dispatch(setLoader(true));
    try {
      const { data } = await axiosInstance(`/api/user/callback-timeslots`);
      if (data) {
        const slots = data.data.map((e) => ({ label: e, value: e }));
        setTimeSlots(slots);
      }
    } catch (error) {}
    dispatch(setLoader(false));
  };

  useEffect(() => {
    fetchCities();
    fetchTimeSlots();
    fetchTestCategories(); // Fetch test categories on component load
    return () => formik.resetForm();
  }, [showGetACallBack]);

  return (
    <div>
      <CustomModal
        onClose={handleCloseModal}
        show={showGetACallBack}
        size="full"
      >
        <div className="custom-get-call get-call-modal">
          <div className="get-a-callback-wrapper">
            <h2>Get A Call Back</h2>
            <div className="form-group ">
              <NameInput
                placeholder="Enter First Name *"
                formik={formik}
                label={'first_name'}
              />
            </div>
            <div className="form-group ">
              <NameInput
                placeholder="Enter Last Name"
                formik={formik}
                label={'last_name'}
              />
            </div>
            <div className="form-group ">
              <NumberInput
                placeholder="Enter Mobile Number *"
                formik={formik}
                label={'mobileno'}
              />
            </div>
            <div className="form-group ">
              <EmailInput
                placeholder="Enter Email"
                formik={formik}
                label={'email'}
              />
            </div>
            <div className="form-group ">
              <SelectBox
                options={cityList}
                placeholder="Choose City *"
                formik={formik}
                label="city"
              />
            </div>
            <div className="form-group ">
              <SelectBox
                options={timeSlots}
                placeholder="Choose Time *"
                formik={formik}
                label="slots"
              />
            </div>
            <div className="form-group">
              <SelectBox
                options={testCategories}
                placeholder="Choose Test Category *"
                formik={formik}
                label="test_category"
              />
            </div>
            <div className="form-group input-group">
              <ReCAPTCHA
                sitekey={Config.GOOGLE_CAPTCHA_KEY}// beta key added
                onChange={onChangeCaptcha}
              />
              {formik.errors.recaptcha && formik.touched.recaptcha ? (
                <p className="error">{formik.errors.recaptcha}</p>
              ) : null}
            </div>
            <div className="form-group submit-action mt-3">
              <button
                onClick={handleCloseModal}
                className="btn btn-md btn-stroke"
              >
                <span>Cancel</span>
              </button>
              <button
                type="submit"
                disabled={
                  !formik.isValid ||
                  formik.isSubmitting ||
                  !formik.dirty
                }
                onClick={formik.handleSubmit}
                className="btn btn-md"
              >
                <span>Submit</span>
              </button>
            </div>
          </div>
        </div>
      </CustomModal>
    </div>
  );
}
function GetACallBackModal({ children, open, handleClose  }) {
  const [showGetACallBack, setShowGetACallBack] = useState(false);
  const [showThankYouModal, setShowThankYouModal] = useState(false);
  const handleCloseThankYouModal = () => setShowThankYouModal(false);

  const handleCloseModal = () => {
    setShowGetACallBack(!showGetACallBack);
    handleClose && handleClose();
  };

  useEffect(() => {
    open && setShowGetACallBack(true);
  }, [open]);

  return (
    <>
      <div onClick={handleCloseModal}>{children}</div>
      <ThankYouModalForCallBack
        show={showThankYouModal}
        handleCloseModal={handleCloseThankYouModal}
      />
      {showGetACallBack && (
        <CallBackModal
          setShowThankYouModal={setShowThankYouModal}
          showGetACallBack={showGetACallBack}
          handleCloseModal={handleCloseModal}
        />
      )}
    </>
  );
}

export default GetACallBackModal;
